import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'

import { generatePath, NavLink } from 'react-router-dom'
import { Navbar, Nav } from 'rsuite'
import CheckSquareO from '@rsuite/icons/legacy/CheckSquareO'
import ProductReviewsGrid from '@components/catalog/productReview/ProductReviewGrid'

import {
  ROUTE_CATALOG_MODERATION_PRODUCT_REVIEWS
} from '@@partner:config/routes'
import CatalogTopMenu from '@components/catalog/CatalogTopMenu'

export default function ProductReviewsPage () {
  const { brandSlug } = usePartner()

  const filter = {
    fields: [ 'id' ],
    op: 'unwrap'
  }

  return (
    <div className="ProductReviewsPage">
      <h1 className="u-heading">Отзывы на товары</h1>
      <CatalogTopMenu />
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<CheckSquareO />}
            as={NavLink}
            to={generatePath(ROUTE_CATALOG_MODERATION_PRODUCT_REVIEWS, {
              brandSlug
            })}
          >
            Модерация отзывов
          </Nav.Item>
        </Nav>
      </Navbar>
        
              
      <ProductReviewsGrid filter={filter} brandSlug={brandSlug} />
    </div>
  )
}
